import { Link } from 'react-router-dom';
import { useCookies } from 'react-cookie';

import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useState } from 'react';

import tokenDistroImg from '../images/TokenDistro.png';
import emissionsImg from '../images/emissions.png';

export default function Learn({ validChain }) {
    return (
        <>
        <Navbar validChain={validChain} />
        <main className="bf-lrnMain">
  <div className="bf-lrnOuterCont">
    <h1>Biometric Finance (BioFi) - Utility Token</h1>
    <hr />
    <div className="bf-lrnInnerCont">
      <div className="bf-lrnLft">
        <div className="bf-lrnInfotxt">
          Finnovant Inc. creates secure biometric solutions, enabling people to
          design, develop and interact with emerging products that have the
          potential to make a lasting impact around the world by improving data
          security and validation for the common person.
        </div>
        <div className="bf-lrnInfotxt">
          Problem: With data breaches and hacks on the rise, consumers in the
          21st century have lost faith in the ability of service providers to
          protect their identity and are looking for a solution that can help
          protect their sensitive information.
        </div>
        <div className="bf-lrnInfotxt">
          Solution: A decentralized finance “Defi” token with real utility
          providing rewards, which can be pledged for mining, used to validate
          identity, and for payments within the BioFi ecosystem. The BioFi
          ecosystem addresses the concerns many people have about safeguarding
          their personal data and being safe from exploitation by fraudsters.
          This is significant for users of personal devices who care about their
          freedom and personal data. Our team brings top-tier experience from
          many industry verticals and emerging technologies. Major components of
          the BioFi ecosystem have already launched in the mobile app stores.
        </div>
        <div className="bf-lrnInfotxt">
          Technical: BioFi is a utility token and a secure set of solutions
          developed by our team and our providers that leverages biometrics, the
          blockchain, and decentralized services. New providers are welcome to
          join the ecosystem. Biometrics on mobile devices provide one level of
          security, while BioFi goes a level beyond to secure your apps, data,
          and personal information. The BioFi token will launch in Q1 - Q2 of
          2022 as an ERC20 token.
        </div>
        <div className="bf-lrnInfotxt">
          Revenue: Solution providers can independently create their own
          solutions by easily integrating with the BioFi ecosystem through
          common API interfaces.
        </div>
        <div className="bf-lrnInfotxt">
          Sample solutions may deliver ability to: secure sensitive information
          with biometric access, allow access and to pay for ecosystem utility
          solutions, earn utility rewards by pledging assets, store utility
          value and accumulate rewards, finance health utility savings and
          coverages and deliver biometrically secure solutions/products for
          enterprise utility.
        </div>
      </div>
      <div className="bf-lrnRt">
        <div className="bf-lrnRtContent">
          <span className="bf-lrnHdrtxt ">Token Distribution</span>
          <img src={tokenDistroImg} className="bf-lrnImg" alt="" />
        </div>
        <div className="bf-lrnRtContent">
          <span className="bf-lrnHdrtxt ">Token Emissions</span>
          <img src={emissionsImg} className="bf-lrnImg" alt="" />
        </div>
      </div>
    </div>
    <hr />
    <div className="bf-lrnLinks">
      <div className="bf-lrnlnks">
        <a href="https://biometricfinancial.org/wp-content/uploads/BioFi_Whitepaper.pdf">
          WhitePaper
        </a>
        |
      </div>
      <div className="bf-lrnlnks">
        <a href="https://biometricfinancial.org/about-us/">Team </a> |
      </div>
      <div className="bf-lrnlnks">
        <a href="https://biometricfinancial.org">
          Biometric Financial - Website
        </a>
        |
      </div>
      <div className="bf-lrnlnks">
        <a href="https://finnovant.com">Finnovant - Website </a>
      </div>
    </div>
  </div>
</main>
        <Footer />
        </>
    )
}